export default {
  placeholder: 'Enter restaurant name',
  labels: {
    cant_find_place: "Can't find the place in the list?",
    reset_categories: 'Reset place categories',
  },
};
